import { useMemo } from "react";
import { Redirect } from "react-router-dom";
import { useBusinessesWithCurrentPlan } from "src/hooks/useBusinessesWithCurrentPlan";
import { activeLBIDGroupId, inactiveLBIDGroupId, lbidGroupReduce } from "src/utils/lbid-group-reduce";

const RedirectToFirstBusiness = () => {
  const { businesses, loading } = useBusinessesWithCurrentPlan();

  const sorted = useMemo(() => {
    if (!businesses || businesses.length === 0) {
      return null;
    }
    const groups = [...businesses].reduce(lbidGroupReduce, [] as Array<ReturnType<typeof lbidGroupReduce>[0]>);

    const inactiveGroup = groups.find(({ id }) => id === inactiveLBIDGroupId);
    const activeGroup = groups.find(({ id }) => id === activeLBIDGroupId);

    if (activeGroup?.options.length) {
      return activeGroup.options;
    }

    if (inactiveGroup?.options.length) {
      return inactiveGroup.options;
    }

    return [];
  }, [businesses]);

  if (loading || sorted === null) {
    return null;
  }

  if (sorted[0]?.id) {
    return <Redirect to={`/business/${sorted[0].id}`} />;
  }

  return <Redirect to={"/home"} />;
};

export default RedirectToFirstBusiness;
